@if(footer){
<div [ngClass]="footer.layout?.class | class" [ngStyle]="footer.layout?.style | style">
  @for (element of footer.content; track $index) {
  <ng-container *ngComponentOutlet="element.componentType; inputs: { element: element }"></ng-container>
  }
</div>
}
